"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingBagCounter = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ShoppingBagCounter = ({
  shoppingBagQuantity,
  children
}) => {
  const [isAnimationActive, setIsAnimationActive] = (0, _react.useState)(false);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  (0, _react.useEffect)(() => setIsAnimationActive(true), [shoppingBagQuantity]);
  (0, _react.useEffect)(() => {
    if (isAnimationActive) {
      setTimeout(() => setIsAnimationActive(false), _constants.MINIBAG_COUNTER_ANIMATION_TIMEOUT);
    }
  }, [isAnimationActive]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    isAnimationActive: isAnimationActive,
    "data-testid": getTestId(_constants.SHOPPING_BAG_COUNTER_ROOT),
    badgeContent: shoppingBagQuantity,
    color: "primary",
    children: children
  });
};
exports.ShoppingBagCounter = ShoppingBagCounter;
